import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgCardGrid = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M5.103 8.005A1 1 0 0 1 6 9v4l-.005.102a1 1 0 0 1-.892.893L5 14H1a1 1 0 0 1-.995-.898L0 13V9a1 1 0 0 1 1-1h4zM1.5 12.5h3v-3h-3zM13.103 8.005A1 1 0 0 1 14 9v4l-.005.102a1 1 0 0 1-.893.893L13 14H9a1 1 0 0 1-.995-.898L8 13V9a1 1 0 0 1 1-1h4zM9.5 12.5h3v-3h-3zM5.103.005A1 1 0 0 1 6 1v4l-.005.103a1 1 0 0 1-.892.892L5 6H1a1 1 0 0 1-.995-.897L0 5V1a1 1 0 0 1 1-1h4zM1.5 4.5h3v-3h-3zM13.103.005A1 1 0 0 1 14 1v4l-.005.103a1 1 0 0 1-.893.892L13 6H9a1 1 0 0 1-.995-.897L8 5V1a1 1 0 0 1 1-1h4zM9.5 4.5h3v-3h-3z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCardGrid);
export default ForwardRef;
